var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 53,
    viewBox: "0 0 177 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.508 52.0162H7.14833C3.56758 52.0162 0.651367 49.0846 0.651367 45.5142V6.50202C0.651367 2.91861 3.56758 0 7.14833 0H169.508C173.085 0 176.005 2.91861 176.005 6.50202V45.5142C176.005 49.0846 173.085 52.0162 169.508 52.0162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0284 17.2071C91.8574 17.2071 90.8702 16.7952 90.0896 15.9845C89.3154 15.1965 88.8831 14.1101 88.9024 13.001C88.9024 11.8174 89.3025 10.8153 90.0896 10.0208C90.867 9.21007 91.8541 8.79822 93.0252 8.79822C94.1832 8.79822 95.1704 9.21007 95.9639 10.0208C96.7511 10.8412 97.1511 11.8433 97.1511 13.001C97.1382 14.1879 96.7382 15.19 95.9639 15.9813C95.1865 16.7985 94.1994 17.2071 93.0284 17.2071ZM58.1854 17.2071C57.0402 17.2071 56.0467 16.8017 55.2337 16.0007C54.4273 15.203 54.0176 14.1944 54.0176 13.0043C54.0176 11.8141 54.4273 10.8056 55.2337 10.0078C56.0305 9.20682 57.0241 8.80146 58.1854 8.80146C58.7532 8.80146 59.3048 8.91496 59.8339 9.14521C60.3532 9.36897 60.7758 9.6738 61.0887 10.0467L61.1662 10.1408L60.292 11.0034L60.2016 10.8964C59.7081 10.3062 59.0468 10.0176 58.1725 10.0176C57.3919 10.0176 56.7112 10.2964 56.1499 10.8477C55.5854 11.4023 55.2983 12.1287 55.2983 13.0075C55.2983 13.8863 55.5854 14.6127 56.1499 15.1673C56.7112 15.7186 57.3919 15.9975 58.1725 15.9975C59.0048 15.9975 59.7048 15.7186 60.25 15.1673C60.5726 14.843 60.7726 14.389 60.8436 13.815H58.0403V12.6021H62.0468L62.063 12.7124C62.092 12.9167 62.121 13.1275 62.121 13.3221C62.121 14.4409 61.7855 15.3456 61.121 16.0137C60.3661 16.805 59.379 17.2071 58.1854 17.2071ZM104.513 17.0352H103.277L99.4931 10.9483L99.5253 12.0444V17.032H98.2898V8.97334H99.6995L99.7382 9.03495L103.296 14.7684L103.264 13.6755V8.97334H104.513V17.0352ZM83.7442 17.0352H82.4926V10.1862H80.3216V8.97334H85.912V10.1862H83.741V17.0352H83.7442ZM79.3022 17.0352H78.0537V8.97334H79.3022V17.0352ZM72.2858 17.0352H71.0374V10.1862H68.8664V8.97334H74.4569V10.1862H72.2858V17.0352ZM68.076 17.0222H63.2888V8.97334H68.076V10.1862H64.5405V12.3978H67.7309V13.5977H64.5405V15.8094H68.076V17.0222ZM91.0057 15.1511C91.5638 15.7121 92.2413 15.9942 93.0284 15.9942C93.8381 15.9942 94.4994 15.7186 95.051 15.1511C95.5994 14.5998 95.8768 13.8766 95.8768 13.0043C95.8768 12.1319 95.5994 11.4055 95.0542 10.8575C94.4962 10.2964 93.8155 10.0143 93.0316 10.0143C92.2219 10.0143 91.5606 10.29 91.0122 10.8575C90.4638 11.4088 90.1864 12.1319 90.1864 13.0043C90.1864 13.8766 90.4606 14.603 91.0057 15.1511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7864 28.2912C85.7379 28.2912 83.2669 30.6164 83.2669 33.8236C83.2669 37.0017 85.754 39.356 88.7864 39.356C91.8349 39.356 94.3059 37.0146 94.3059 33.8236C94.3059 30.6164 91.8349 28.2912 88.7864 28.2912ZM88.7864 37.1638C87.1186 37.1638 85.6831 35.7758 85.6831 33.8106C85.6831 31.8163 87.1218 30.4575 88.7864 30.4575C90.4542 30.4575 91.8897 31.8163 91.8897 33.8106C91.8929 35.7888 90.4542 37.1638 88.7864 37.1638ZM76.7441 28.2912C73.6956 28.2912 71.2246 30.6164 71.2246 33.8236C71.2246 37.0017 73.7118 39.356 76.7441 39.356C79.7926 39.356 82.2636 37.0146 82.2636 33.8236C82.2636 30.6164 79.7893 28.2912 76.7441 28.2912ZM76.7441 37.1638C75.0763 37.1638 73.6408 35.7758 73.6408 33.8106C73.6408 31.8163 75.0795 30.4575 76.7441 30.4575C78.4119 30.4575 79.8474 31.8163 79.8474 33.8106C79.8474 35.7888 78.4119 37.1638 76.7441 37.1638ZM62.4146 29.9808V32.3222H68.0051C67.8342 33.6355 67.4019 34.6052 66.7406 35.27C65.9212 36.0937 64.6566 36.9887 62.4276 36.9887C58.992 36.9887 56.3048 34.1998 56.3048 30.7461C56.3048 27.2924 58.992 24.5035 62.4276 24.5035C64.2824 24.5035 65.6341 25.2397 66.6374 26.1801L68.289 24.5197C66.8954 23.1772 65.0405 22.1492 62.4405 22.1492C57.7274 22.1492 53.7725 26.0082 53.7725 30.7331C53.7725 35.471 57.7242 39.3171 62.4405 39.3171C64.9857 39.3171 66.8954 38.4804 68.4051 36.9044C69.9439 35.3575 70.431 33.175 70.431 31.4141C70.431 30.8661 70.3891 30.3732 70.302 29.9548H62.4114C62.4146 29.9516 62.4146 29.9808 62.4146 29.9808ZM121.026 31.8033C120.565 30.5613 119.171 28.2783 116.313 28.2783C113.481 28.2783 111.126 30.5191 111.126 33.8106C111.126 36.9173 113.455 39.343 116.587 39.343C119.103 39.343 120.568 37.7962 121.171 36.8882L119.303 35.6299C118.684 36.5541 117.823 37.1606 116.6 37.1606C115.365 37.1606 114.5 36.5963 113.926 35.484L121.284 32.4194C121.284 32.4227 121.026 31.8033 121.026 31.8033ZM113.523 33.6517C113.465 31.5147 115.174 30.4283 116.397 30.4283C117.361 30.4283 118.165 30.905 118.439 31.599L113.523 33.6517ZM107.545 39.0123H109.961V22.7588H107.545V39.0123ZM103.577 29.5203H103.49C102.945 28.8685 101.909 28.2783 100.587 28.2783C97.8415 28.2783 95.3124 30.7072 95.3124 33.8269C95.3124 36.9336 97.8286 39.3333 100.587 39.3333C101.893 39.3333 102.945 38.7399 103.49 38.0751H103.577V38.8696C103.577 40.9807 102.455 42.119 100.645 42.119C99.1641 42.119 98.2447 41.0488 97.8705 40.1538L95.7705 41.0358C96.3737 42.4951 97.9834 44.3014 100.642 44.3014C103.474 44.3014 105.874 42.6249 105.874 38.5356V28.609H103.59V29.5203C103.593 29.5203 103.577 29.5203 103.577 29.5203ZM100.803 37.1638C99.1351 37.1638 97.7415 35.7629 97.7415 33.8269C97.7415 31.8746 99.1351 30.4607 100.803 30.4607C102.455 30.4607 103.735 31.8908 103.735 33.8269C103.751 35.7629 102.458 37.1638 100.803 37.1638ZM132.339 22.7588H126.562V39.0123H128.978V32.8572H132.342C135.017 32.8572 137.646 30.9083 137.646 27.8145C137.646 24.7208 135.026 22.7588 132.339 22.7588ZM132.41 30.5872H128.975V25.0094H132.41C134.22 25.0094 135.243 26.5109 135.243 27.7983C135.243 29.0728 134.207 30.5872 132.41 30.5872ZM147.33 28.262C145.575 28.262 143.765 29.0436 143.017 30.7461L145.159 31.6411C145.62 30.7461 146.465 30.4413 147.359 30.4413C148.611 30.4413 149.875 31.1936 149.904 32.5362V32.7081C149.472 32.4616 148.524 32.0854 147.388 32.0854C145.075 32.0854 142.73 33.3566 142.73 35.7402C142.73 37.9226 144.627 39.3236 146.74 39.3236C148.362 39.3236 149.256 38.5874 149.814 37.7346H149.901V38.9928H152.23V32.7664C152.23 29.8673 150.088 28.262 147.33 28.262ZM147.027 37.1638C146.236 37.1638 145.13 36.7747 145.13 35.7758C145.13 34.5176 146.511 34.0409 147.688 34.0409C148.753 34.0409 149.256 34.2711 149.888 34.5889C149.714 36.0483 148.488 37.1508 147.027 37.1638ZM160.727 28.609L157.953 35.6591H157.866L154.992 28.609H152.391L156.704 38.4642L154.246 43.9415H156.763L163.398 28.609H160.727ZM138.978 39.0123H141.394V22.7588H138.978V39.0123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1484 9.79685C13.7742 10.2022 13.5581 10.8216 13.5581 11.6323V40.3872C13.5581 41.1979 13.7742 41.8173 14.1613 42.2064L14.2614 42.294L30.2876 26.1832V25.8233L14.2484 9.70929L14.1484 9.79685Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6202 31.5698L30.2749 26.1963V25.8201L35.6202 20.4466L35.7363 20.5179L42.0591 24.1305C43.8688 25.1553 43.8688 26.8481 42.0591 27.8858L35.7363 31.4984L35.6202 31.5698Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7362 31.4984L30.2747 26.0082L14.1484 42.2195C14.7388 42.8551 15.7291 42.9264 16.8356 42.307L35.7362 31.4984Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7362 20.518L16.8356 9.72565C15.7291 9.09004 14.7356 9.1776 14.1484 9.81321L30.2747 26.0083L35.7362 20.518Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6203 31.3817L16.8488 42.1027C15.8004 42.7091 14.8649 42.6669 14.2616 42.1156L14.1616 42.2162L14.2616 42.3037C14.8649 42.8518 15.8004 42.8972 16.8488 42.2908L35.7494 31.4984L35.6203 31.3817Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.059 27.6977L35.604 31.3817L35.7201 31.4984L42.0429 27.8858C42.9494 27.367 43.3945 26.6859 43.3945 26.0082C43.3397 26.6308 42.8784 27.221 42.059 27.6977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8356 9.91354L42.0589 24.3185C42.8783 24.7823 43.3396 25.3887 43.4106 26.0081C43.4106 25.3303 42.9654 24.6493 42.0589 24.1304L16.8356 9.72545C15.0259 8.68448 13.5581 9.55358 13.5581 11.6323V11.8204C13.5581 9.73843 15.0259 8.88554 16.8356 9.91354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.8501,
    y1: 11.3221,
    x2: 3.16096,
    y2: 18.1311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 44.4192,
    y1: 26.0082,
    x2: 13.1184,
    y2: 26.0082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 32.7664,
    y1: 28.9957,
    x2: 11.9971,
    y2: 63.7689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 10.0877,
    y1: 0.232684,
    x2: 19.3537,
    y2: 15.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175.353,
    height: 52.0162,
    fill: "white",
    transform: "translate(0.651367)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayStore);
export default __webpack_public_path__ + "static/media/googlePlayStore.08720200c647cd5e3a43932648d0f5a0.svg";
export { ForwardRef as ReactComponent };